module.exports = __webpack_public_path__ + "static/img/logo.da2b525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 22